import { createSelector } from 'reselect';

import * as Service from 'types/service';
import { GuestData } from 'state/calendarCrm';
import { calendarCrmGuestDataSelector } from 'selectors/calendarCrmSelectors';
import { elmPartiesSelector } from 'selectors/service/elmPartiesSelector';

export interface PartiesGuestData {
  parties?: NumericDictionary<Service.PartyFromElm>;
  guestData: NumericDictionary<GuestData>;
}
// 2019/05/01 KM this selector exists because the types for reselect have a max number of arguments
// maybe they're trying to tell us something?
export const partiesGuestDataSelector = createSelector(
  calendarCrmGuestDataSelector,
  elmPartiesSelector,
  (
    guestData: NumericDictionary<GuestData>,
    parties?: NumericDictionary<Service.PartyFromElm>
  ): PartiesGuestData => {
    return {
      parties,
      guestData,
    };
  }
);
